module.exports = __webpack_public_path__ + "7b1120e28af5ad3cef1de0750eec7fb5.png";